
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-businesses/branded-sm-graphics",
      function () {
        return require("private-next-pages/for-businesses/branded-sm-graphics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-businesses/branded-sm-graphics"])
      });
    }
  